import React from 'react';
import { FormattedMessage } from 'react-intl';
import defaultImage from 'views/anyguide/tours/item/images/default_image.png';
import './photo.scss';

class CoverPhoto extends React.Component {
  static displayName = 'MobileCheckout-CoverPhoto';

  render() {
    const { picture, tourName, guideName, hasResource, resourceName } =
      this.props;
    const picUrl = picture || defaultImage;
    return (
      <div
        className="MobileCheckout-CoverPhoto"
        style={{ backgroundImage: `url('${picUrl}')` }}
      >
        <span className="text">
          <span className="title">
            <h1 className="name">
              <b>{tourName}</b>
            </h1>
          </span>
          <span className="guide">
            <FormattedMessage
              id="WITH_NAME"
              defaultMessage="With {name}"
              values={{ name: hasResource ? resourceName : guideName }}
            />
          </span>
        </span>
      </div>
    );
  }
}

export default CoverPhoto;
